/*
Based on Material Dashboard 2 React by Creative Tim (https://www.creative-tim.com)
Licensed under the MIT License (see LICENSE)

Original Copyright (c) 2013-2021 Creative Tim
Modifications (c) 2025 CodeWeave Solutions (Pty) Ltd
*/

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const Template = ({ name, description, onClick }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDBox ml={2} lineHeight={1}>
      <MDTypography 
        display="block" 
        variant="button" 
        fontWeight="medium"
        sx={{ 
          cursor: 'pointer',
          '&:hover': {
            color: 'info.main',
            textDecoration: 'underline'
          }
        }}
        onClick={onClick}
      >
        {name}
      </MDTypography>
      <MDTypography variant="caption">{description}</MDTypography>
    </MDBox>
  </MDBox>
);

export default function data(apiTemplates = [], selectedFolder = "all", searchQuery = "", onTemplateClick) {
  // Filter templates based on selected folder and search query
  let filteredTemplates = apiTemplates;
  
  // Map folder IDs to folder names
  const folderNameMap = {
    1: "Investments",
    2: "Medical Aid and Gap",
    3: "Misc",
    4: "Onboarding",
    5: "Risk"
  };
  
  // Filter by folder first
  if (selectedFolder !== "all") {
    // Map folder names to folder IDs for filtering
    const folderIdMap = {
      "investments": 1,
      "medical-aid-gap": 2, 
      "misc": 3,
      "onboarding": 4,
      "risk": 5
    };
    
    const targetFolderId = folderIdMap[selectedFolder];
    filteredTemplates = apiTemplates.filter(template => template.folder_id === targetFolderId);
  }

  // Filter by search query
  if (searchQuery.trim()) {
    const query = searchQuery.toLowerCase().trim();
    filteredTemplates = filteredTemplates.filter(template => 
      template.name.toLowerCase().includes(query)
    );
  }

  // Convert filtered templates to table rows
  const rows = filteredTemplates.map(template => ({
    template: (
      <Template 
        name={template.name} 
        description={folderNameMap[template.folder_id] || "Unknown Folder"}
        onClick={() => onTemplateClick && onTemplateClick(template)}
      />
    ),
    lastModified: (
      <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
        {new Date().toLocaleDateString()} {/* Using current date as placeholder */}
      </MDTypography>
    ),
  }));

  return {
    columns: [
      { Header: "template", accessor: "template", width: "45%", align: "left" },
      { Header: "last modified", accessor: "lastModified", align: "center" },
    ],
    rows,
  };
} 